import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

const auth0AuthConfig: AuthConfig = {
  issuer: environment.auth0Issuer,
  redirectUri: window.location.origin,
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  clientId: environment.auth0ClientId,
  responseType: 'code',
  scope: 'openid profile email offline_access access_token:email',
  useSilentRefresh: false,
  timeoutFactor: 0.75,
  logoutUrl: window.location.origin,
  showDebugInformation: false,
  sessionChecksEnabled: false,
  strictDiscoveryDocumentValidation: false,
  customQueryParams: {
    audience: environment.auth0Audience,
  },
};

export function createAuthConfig(): AuthConfig {
  return auth0AuthConfig;
}
